export enum CampaignName {
  FLASH_SALE_STAR_WARS = 'FLASH_SALE_STAR_WARS',
  FIRESHIP_2025 = 'FIRESHIP_2025',
  MADHAT_2025 = 'MADHAT_2025',
  FLASH_SALE_BEAT_THE_PRICE_HIKE = 'FLASH_SALE_BEAT_THE_PRICE_HIKE_2025',
  THE_BEARDED_IT_DAD_2025 = 'THE_BEARDED_IT_DAD_2025',
  TYLER_RAMSBEY_2025 = 'TYLER_RAMSBEY_2025',
}
